<template>
  <div v-loading="loading">
    <div style="margin-left:100px">
      <h3>Zone Image</h3>
      <img :src="zoneImage" width="200" height="150" />
    </div>
    <el-form
      ref="form"
      :model="form"
      label-width="250px"
      @submit.prevent="onSubmit"
      style="margin:20px;width:60%;min-width:600px;"
    >
      <el-form-item label="Upload new Image">
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload" />
      </el-form-item>
      <el-form-item style="margin-top:10px">
        <el-button type="primary" style="margin-top:10px" @click="submitFile">Save Image</el-button>
      </el-form-item>

      <input style="color:white; outline: none; border:none" ref="hidden" />
    </el-form>
  </div>
</template>

<script>

import Axios from 'axios';
import echarts from 'echarts'
import IOService from '@/api/io.service';
import UserService from '@/api/user.service';
import constants from '@/common/constants/system'


export default {
  data() {
    return {
      loading: false,
      form: {},
      file: '',
      user: this.$session.get('User'),
      zoneImage: '',
      zoneImageSequence: 1
    }
  },
  mounted() {
    this.zoneImage = "https://www.variablevac.com/hosting/img/zones/" + this.user.activeZone + ".jpg?t=" + this.zoneImageSequence++;
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    submitFile() {
      UserService.uploadZoneImage(this.user.activeZone, this.file).then(response => {
        if (response.data.result == 'success') {
          const h = this.$createElement;
          this.$notify({
            title: 'Image Upload',
            message: 'Sucess',
            type: 'info'
          });
          this.zoneImage = "https://www.variablevac.com/hosting/img/zones/" + this.user.activeZone + ".jpg?t=" + this.zoneImageSequence++;
        } else {
          const h = this.$createElement;
          this.$notify({
            title: 'Image Upload',
            message: response.data.result,
            type: 'error'
          });
        }
      });
    }
  }
}

</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>


// WEBPACK FOOTER //
// ZoneInfo.vue?ef5587c6